import s from './TopBar.module.css';

export default function TopBar({ variant = 'mobile', left, center, right, className = '' }) {
  const cls = [s.bar, variant === 'desktop' ? s.desktop : ''].filter(Boolean).join(' ');
  return (
    <header className={`${cls} ${className}`.trim()}>
      {left ?? <span className={s.brand}>Bar<span className={s.dot}>Chain</span></span>}
      {center ?? <div className={s.spacer} />}
      <div className={s.right}>{right}</div>
    </header>
  );
}
